const UserMsalErrorPage: React.FC = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="bg-white rounded-lg shadow-md p-6 max-w-md text-center">
        <h1 className="text-base font-bold text-red-600">Access Denied</h1>
        <p className="mt-4 text-gray-600">Something went wrong !!!</p>
      </div>
    </div>
  )
}
export default UserMsalErrorPage
